import {
  Avatar,
  Button,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Spinner,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import SigninModal from "../SigninModal";
import { Link, useNavigate } from "react-router-dom";
import { Cookies } from "typescript-cookie";
import { User } from "../../const/types";
import { SignOut } from "@phosphor-icons/react/dist/ssr";
import { iconSize } from "../../const/sizes";
import useTrigger from "../../globalState/useTrigger";
import cr from "../../lib/request";
import { CaretDown } from "@phosphor-icons/react";
import useScreenWidth from "../../lib/useGetScreenWidth";

export default function AuthComponent() {
  const userCookie = Cookies.get("user") as string;
  const [loading, setLoading] = useState<boolean>(false);
  const sw = useScreenWidth();
  const { trigger, setTrigger } = useTrigger();
  const toast = useToast();
  const navigate = useNavigate();

  const onSignout = () => {
    setLoading(true);
    const url = `api/usercourse/logout`;
    cr.post(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: "Berhasil sign out",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          navigate("/");
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: "Gagal sign out",
          description: e?.response?.data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        Cookies.remove("user");
        setTrigger(!trigger);
        setLoading(false);
      });
  };

  if (userCookie) {
    const user: User = JSON.parse(userCookie);

    return (
      <HStack w={sw >= 768 ? "219.86px" : ""} justify={"flex-end"}>
        {!loading ? (
          <Menu>
            <MenuButton
              as={Button}
              leftIcon={<Icon as={CaretDown} fontSize={iconSize} />}
              className="btn-clear"
              borderRadius={"full"}
              pr={0}
            >
              <Avatar name={user?.name} size={"md"} />
            </MenuButton>

            <MenuList>
              <MenuItem as={Link} to={"/mycourses"}>
                <HStack mx={"auto"}>
                  <Text fontWeight={500}>Course Saya</Text>
                </HStack>
              </MenuItem>

              {/* <MenuItem as={Link} to={"/mycertificates"}>
                <HStack mx={"auto"}>
                  <Text fontWeight={500}>Sertifikat Saya</Text>
                </HStack>
              </MenuItem> */}

              <MenuDivider />

              <MenuItem onClick={onSignout}>
                <HStack mx={"auto"} color={"red.500"}>
                  <Icon as={SignOut} fontSize={iconSize} />
                  <Text>Sign out</Text>
                </HStack>
              </MenuItem>
            </MenuList>
          </Menu>
        ) : (
          <Spinner />
        )}
      </HStack>
    );
  }

  return (
    <HStack>
      <Text display={"none"}>{trigger}</Text>

      <SigninModal />

      <Button flexShrink={0} as={Link} to={"/register"} colorScheme="p">
        Daftar Gratis
      </Button>
    </HStack>
  );
}
